import type { Ticket } from "@sd/types/ticket";
import { resolveTicketPriorityLabel } from "@sd/lib/priorityListingUtils";
import { normalizePriority } from "@sd/lib/ticketStreamUtils";

/** Map API priority fields → workbench/admin `Ticket` priority props. */
export function ticketPriorityFieldsFromApi(
  input: {
    priorityId?: string;
    priority?: string;
    priorityLabelFromApi?: string;
  },
  priorityIdToLabel: Map<string, string>,
  slaPriorityById?: Record<string, string>
): Pick<Ticket, "priority" | "priorityId" | "priorityLabel"> {
  const hasPriority =
    Boolean(input.priorityId?.trim()) ||
    Boolean(input.priority?.trim() && input.priority !== "—") ||
    Boolean(input.priorityLabelFromApi?.trim());

  if (!hasPriority) {
    return { priority: "P3", priorityId: input.priorityId };
  }

  const label = resolveTicketPriorityLabel(
    input.priorityId,
    input.priority,
    priorityIdToLabel,
    { slaPriorityById, priorityLabelFromApi: input.priorityLabelFromApi }
  );

  return {
    priorityId: input.priorityId,
    priorityLabel: label !== "—" ? label : undefined,
    priority:
      label !== "—"
        ? (normalizePriority(label) as Ticket["priority"])
        : "P3",
  };
}
